import React, { Component, useEffect, useState } from 'react'
import "./style.css";
import styled from "styled-components";
import { CloseButton, Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { KTCookie } from "../../../_metronic/_assets/js/components/cookie";
import { getDiscountCode } from "./../Auth/_redux/authCrud";
import AuthModal from "../RUComponent/AuthModal";

const Container = styled.div`
  min-height: 70px;
  height: auto;
  border-radius: 20px;
  position: relative;

  vertical-align: middle;
  display: table-cell;
  text-align: center;
`;

const IConContainer = styled.div`
  top: -30%;
  position: absolute;
  left: 0;
  right: 0;
`;

const Icon = styled.img`
  max-width: ${(props) => (props.w ? props.w : "20%")};
  height: auto;
  object-fit: contain;
  margin-top: -10%;
`;

const First = styled.div``;
const Second = styled.div``;

const Span = styled.div`
  width: 100%;
  top: 10%;
  color: #9d9d9d;
  text-align: center;
  font-size: 12px;
`;

const Input = styled.input`
  width: 100%;
  height: 35px;
  border-radius: 7px;
  margin-top: 5%;
  border: 1px solid #c9c9c9;
  padding: 10px;

  &:hover: { color: 'blue !important' },
`;

const Button = styled.button`
  width: 100%;
  height: 35px;
  border-radius: 7px;
  margin-top: 4%;
  border: none;
  color: ${(props) => (props.step === 1 ? "#ffffff" : "9d9d9d")};
  background-color: ${(props) => (props.step === 1 ? "#00c763" : "none")};
`;

function Popup() {

  const [showPopup, setShowPopup] = useState(true);
  // const [toggleModal, setToggleModal] = useState(true);
  // const [showPopup, toggleModal] = useState(true);
  const [mobile, setMobile] = useState("");
  const [discountCode, setDiscountCode] = useState();
  const [step, setStep] = useState(1);
  const [error, setError] = useState(null);
  const [repetitious, setRepetitious] = useState(false);
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [check, setCheck] = useState(true);

  const phoneValidation = /^09\d{9}$/;

  useEffect(() => {
    if (KTCookie.getCookie('popup_discount')) {
      console.log("popup_discount already set")
      setShowPopup(false);
    } else {
      console.log("popup_discount not set")
      setShowPopup(true);
    }
  }, [])

  useEffect(() => {
    if (open === true) {
      setShowPopup(false)
    }
  }, [open])

  useEffect(() => {
    if (openLogin === true) {
      setShowPopup(false)
    }
  }, [openLogin])

  const setCookie = () => {
    var expires = new Date(2147483647 * 1000).toUTCString(); // can not expire
    KTCookie.setCookie("popup_discount", "true", { expires: expires })
    console.log("cooki popup_discount set")
  }

  const handleChange = (e) => {
    setMobile(e.target.value);
  }

  const handleClick = () => {
    if (mobile && phoneValidation.test(mobile)) {
      setError("");
      registerTakhfif();
      setStep(2);
      console.log("code", discountCode)
    } else {
      setError("فرمت موبایل وارد شده اشتباه است");
    }
  }

  const registerTakhfif = () => {
    const data = {
      phone: mobile,
    }
    getDiscountCode(data).then((res) => {
      console.log("Discount Code", res);
      setCookie();
      setDiscountCode(res.data.discountCode)
    }).catch(err => {
      console.log("errorrr", err.response.data)
      if (err.response.data.status === 403) {
        setCookie();
        setRepetitious(true)
        setCheck(false)
      } else {
        console.log(err)
      }
    })
  }

  const handleClose = () => {
    setShowPopup(false);
  }

  const handleNever = () => {
    setCookie();
    setShowPopup(false);
  }

  const handleClickOpen = () => {
    setOpen(true)
  };

  const handleCloseRegister = () => {
    setOpen(false);
  };

  const handleClickOpenLogin = () => {
    setOpenLogin(true)
  };

  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  return (
    <>
      <Modal
        show={showPopup}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={handleClose}
      // className="m-10"
      >
        <Modal.Header closeButton
          style={{ marginLeft: "auto", zIndex: "100", border: "none" }}
          className="py-4">
          <Button variant="secondary" onClick={handleClose}>
            X
          </Button>
        </Modal.Header>
        <Modal.Body
          className="mt-0"
          style={{ width: "90%", minHeight: "340px", height: "auto", display: "table", justifyContent: "center", textAlign: "center" }}
        >
          <Container>
            <IConContainer>
              {/* <Icon w="8rem" alt="popup-ball" src={toAbsoluteUrl("./media/popup/ball.png")} /> */}
            </IConContainer>

            {
              step === 1 ?

                <First>
                  {/* <Icon w="22rem" alt='popup' src={toAbsoluteUrl("./media/popup/25code.png")} /> */}
                  <Icon w="25rem" alt='popup' src={toAbsoluteUrl("./media/popup/30code.png")} />
                  <Span>
                    برای دریافت کد تخفیف شماره تماس خود را وارد کنید
                  </Span>

                  <div className='row'>

                    <div className='col-md-12 col-sm-12'>
                      <Input
                        placeholder='شماره تماس خود را وارد کنید'
                        value={mobile}
                        onChange={handleChange}
                      />
                    </div>

                    <div style={{ color: 'red', padding: "10px" }}>
                      {error}
                    </div>


                    <div className='col-md-12 col-sm-12'>
                      <Button step={1} onClick={handleClick}>
                        مرحله بعد
                      </Button>
                    </div>

                    {/* <div className='col-md-6 col-sm-12'>

                    <Button step={2} onClick={handleClose}>
                      فعلا نه!
                    </Button>
                  </div> */}
                  </div>
                </First>
                :
                <>
                  {!repetitious && discountCode ?
                    <Second>
                      <Icon w="12rem" alt="popup-check" src={toAbsoluteUrl("./media/popup/Check.png")} className="p-4" />
                      <div style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "60px" }}>کد تخفیف شما</div>
                      <div className='row mx-15' style={{ border: "1px black dashed", borderRadius: "10px", borderLeft: "none" }}>
                        <input
                          style={{ outline: "none", border: "none" }}
                          className="col-9"
                          value={discountCode ? discountCode : ""}
                        // onChange={(e) => setCode(e.target.value)}
                        />
                        <Button
                          onClick={() => {
                            navigator.clipboard.writeText(discountCode ? discountCode : "")
                            setCopied(true)
                          }}
                          style={{ backgroundColor: "#00c763" }}
                          className="col-3 mt-0">
                          {copied ? "کپی شد!" : "کپی"}
                        </Button>
                      </div>
                      <div className="mt-10">
                        برای استفاده از کد تخفیف و خرید بلیط اتوبوس از ایباس
                        <a style={{ color: "rgb(58 74 203)" }}
                          onClick={() => {
                            handleClickOpen()
                          }}
                        > ثبت نام </a>
                        کنید.
                      </div>
                      <div className="">
                        <small>
                          برای مشاهده کدهای تخفیفی فعال خود به حساب کاربری مراجعه کنید
                        </small>
                      </div>
                      <Button
                        step={2}
                        className="mt-10"
                        onClick={handleClose}
                        style={{ backgroundColor: "#ccc" }}>
                        بستن
                      </Button>
                    </Second>
                    : null}
                  {repetitious && !check ?
                    <Second>
                      <div style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "30px" }}>کاربر گرامی شما این کد را دریافت کرده‌اید.</div>
                      <div className="mt-10">
                        جهت مشاهده و استفاده از کد به حساب کاربری خود مراجعه کنید.

                      </div>
                      <Button
                        className="mt-10"
                        onClick={() => {
                          handleClickOpenLogin()
                        }}
                        style={{ backgroundColor: "#00c763" }}>
                        ورود
                      </Button>
                      <Button
                        step={2}
                        className="mt-5"
                        onClick={handleClose}
                        style={{ backgroundColor: "#ccc" }}>
                        بستن
                      </Button>
                    </Second>

                    : null}
                </>
            }

          </Container>

        </Modal.Body>

        <Modal.Footer>
          {
            step === 1 &&
            <Button step={2} onClick={handleNever}>
              دیگه نمیخوام ببینم!
            </Button>
          }
          {/* {
          step === 2 && discountCode &&
          <div>
            کد تخفیف:
            <span>{discountCode}</span>
          </div>
        } */}
        </Modal.Footer>
      </Modal>
      <AuthModal modal={"register"} open={open} handleClose={handleCloseRegister} phone={mobile} />
      <AuthModal modal={"login"} open={openLogin} handleClose={handleCloseLogin} />
    </>
  )
}

export default Popup